export default {
  headerHeight: undefined,
  conversationFooterHeight: undefined,
  overlayOpen: false,
  parentSize: undefined
}
